import * as React from 'react';
import { ModalFullscreen } from '@cian/ui-kit';
import { CloseButton } from '../CloseButton';
import * as styles from './FullscreenGalleryModal.css';

export interface IFullscreenGalleryModalProps {
  afterSlider?: React.ReactNode;
  beforeSlider?: React.ReactNode;
  header: React.ReactNode;
  onClose(): void;
  open: boolean;
  slider: React.ReactNode;
  thumbnails: React.ReactNode;
}

export const FullscreenGalleryModal: React.FC<IFullscreenGalleryModalProps> = ({
  afterSlider,
  beforeSlider,
  header,
  onClose,
  open,
  slider,
  thumbnails,
}) => {
  return (
    <ModalFullscreen open={open} theme="black" onClose={onClose}>
      <div className={styles['container']} data-testid="FullscreenGalleryModal">
        <div className={styles['close-button']}>
          <CloseButton onClick={onClose} />
        </div>
        <div className={styles['header']}>{header}</div>
        {beforeSlider}
        <div className={styles['slider']}>{slider}</div>
        {afterSlider}
        <div className={styles['thumbnails']}>{thumbnails}</div>
      </div>
    </ModalFullscreen>
  );
};
